import { useEffect, useState } from "react";
import { Button, Form, Input, Modal, Space, Table, message } from "antd";
import PageTitle from "../../components/PageTitle";
import { createAdminRole, deleteAdminRole, getAdminRoles, updateAdminRole } from "../../api";

const RoleList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form] = Form.useForm();

  const load = async () => {
    setLoading(true);
    try {
      const res = await getAdminRoles();
      if (res?.success) setData(res.data || []);
      else message.error(res?.error || "加载失败");
    } catch {
      message.error("加载角色列表失败");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const openCreate = () => {
    setEditing(null);
    form.resetFields();
    setModalOpen(true);
  };

  const openEdit = (row) => {
    setEditing(row);
    form.setFieldsValue({ name: row.name, code: row.code });
    setModalOpen(true);
  };

  const handleSubmit = async () => {
    const values = await form.validateFields();
    try {
      if (editing) {
        const res = await updateAdminRole(editing.id, { name: values.name });
        if (!res?.success) throw new Error(res?.error);
        message.success("已更新");
      } else {
        const res = await createAdminRole({
          name: values.name,
          code: values.code,
          permissions: [],
        });
        if (!res?.success) throw new Error(res?.error);
        message.success("已创建");
      }
      setModalOpen(false);
      load();
    } catch (e) {
      message.error(e?.message || "操作失败");
    }
  };

  const handleDelete = (row) => {
    Modal.confirm({
      title: `删除角色「${row.name}」？`,
      content: "将同时移除该角色下所有成员绑定。",
      onOk: async () => {
        const res = await deleteAdminRole(row.id);
        if (res?.success) {
          message.success("已删除");
          load();
        } else {
          message.error(res?.error || "删除失败");
        }
      },
    });
  };

  const columns = [
    { title: "ID", dataIndex: "id", width: 70 },
    { title: "角色名称", dataIndex: "name" },
    { title: "编码", dataIndex: "code" },
    {
      title: "权限数",
      dataIndex: "permissions",
      render: (p) => (Array.isArray(p) ? p.length : 0),
    },
    {
      title: "操作",
      width: 160,
      render: (_, row) => (
        <Space>
          <Button type="link" size="small" onClick={() => openEdit(row)}>编辑</Button>
          <Button type="link" size="small" danger onClick={() => handleDelete(row)}>删除</Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title="角色列表" />
      <div style={{ marginBottom: 12 }}>
        <Button type="primary" onClick={openCreate}>新建角色</Button>
      </div>
      <Table rowKey="id" columns={columns} dataSource={data} loading={loading} size="small" />
      <Modal
        title={editing ? "编辑角色" : "新建角色"}
        open={modalOpen}
        onOk={handleSubmit}
        onCancel={() => setModalOpen(false)}
        destroyOnClose
      >
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="角色名称" rules={[{ required: true, message: "请输入名称" }]}>
            <Input placeholder="如：测试人员" />
          </Form.Item>
          <Form.Item
            name="code"
            label="角色编码"
            rules={[{ required: true, message: "请输入编码" }]}
          >
            <Input placeholder="如：test_staff" disabled={!!editing} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default RoleList;
